import { createVariant } from '../../utils/createVariant';
export const PageTitle = createVariant({
    name: 'page-title',
    tagName: 'h1',
    baseStyle: ({ theme }) => theme.typography.heading1['600PageTitleMobile'],
    responsiveStyles: ({ theme }) => [
        [theme.viewportBreakpoint.md, theme.typography.heading1['700PageTitleTablet']],
        [theme.viewportBreakpoint.lg, theme.typography.heading1['800PageTitleDesktop']],
    ],
});
